"use client";
import React, { createContext, useState, useEffect } from "react";
import {BASE_URL} from '../config/apiConfig';

// Create Context
export const CategoryContext = createContext();

// Provider Component
export const CategoryProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch categories from API
  const fetchCategories = () => {
    fetch(`${BASE_URL}/categories`)
      .then(res => res.json())
      .then(data => {
        if (data.status === 200 && Array.isArray(data.data)) {
          const mapped = data.data.map(c => ({
            id: c.id,
            name: c.category,
            image: `${BASE_URL.replace('/api/client', '')}/uploads/categories/${c.image}`,
          }));
          setCategories(mapped);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching categories:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <CategoryContext.Provider value={{ categories, loading }}>
      {children}
    </CategoryContext.Provider>
  );
};
